/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-07-06 19:26:51
 * @LastEditors: xst
 * @LastEditTime: 2020-07-06 19:27:05
 */

// 导出页面为PDF格式
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function(htmlTitle, elements) {
      /*内容超出时*/
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 25
      document.body.scrollTop = 25;
      // debugger
      let title = htmlTitle;
      let element = document.querySelector(elements);
      //pdf分页
      setTimeout(() => {
        var loadingInstance = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        html2Canvas(element, {
          allowTaint: true,
        }).then(function(canvas) {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height;
          //一页pdf显示html页面生成的canvas高度;
          var pageHeight = contentWidth / 592.28 * 841.89;
          //未生成pdf的html页面高度
          var leftHeight = contentHeight;
          //页面偏移
          var position = 0;
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = 592.28 / contentWidth * contentHeight;
          var pageData = canvas.toDataURL("image/jpeg", 1.0);
          var pdf = new JsPDF("", "pt", "a4");
          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              //避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          pdf.save(title + ".pdf");
        });
        loadingInstance.close();
      }, 50);
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/htmlToPDF.js